import { render, staticRenderFns } from "./ShiftDrawer.vue?vue&type=template&id=3a5899d1"
import script from "./ShiftDrawer.vue?vue&type=script&lang=js"
export * from "./ShiftDrawer.vue?vue&type=script&lang=js"
import style0 from "./ShiftDrawer.vue?vue&type=style&index=0&id=3a5899d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports